import { Box } from "@chakra-ui/react";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Editable, useSlate } from "slate-react";
import { pxToPercents } from "../../utils/functions";
import { Element as RenderedElement, Leaf } from "../../utils/slate";
export const Selected = ({ textData, screenWidth, scale, onUpdate, layoutItem, updateLayoutItem, screenHeight, }) => {
    var _a;
    const [isEditing, setIsEditing] = useState(false);
    const editor = useSlate();
    const renderElement = useCallback((props) => React.createElement(RenderedElement, Object.assign({}, props, { scale: scale, editor: editor })), [scale, editor]);
    const renderLeaf = useCallback((props) => {
        return React.createElement(Leaf, Object.assign({}, props, { scale: scale, screenWidth: screenWidth }));
    }, [scale, screenWidth]);
    const ref = useRef(null);
    useEffect(() => {
        var _a, _b, _c, _d;
        if (!ref.current)
            return;
        let newHeight = layoutItem.height;
        if (layoutItem.unit === "%") {
            newHeight = pxToPercents((((_a = ref.current) === null || _a === void 0 ? void 0 : _a.clientHeight) * ((_b = layoutItem === null || layoutItem === void 0 ? void 0 : layoutItem.scale) !== null && _b !== void 0 ? _b : 1)).toString(), screenHeight);
        }
        if (layoutItem.unit === "px") {
            newHeight = `${Math.round(((_c = ref.current) === null || _c === void 0 ? void 0 : _c.clientHeight) * ((_d = layoutItem === null || layoutItem === void 0 ? void 0 : layoutItem.scale) !== null && _d !== void 0 ? _d : 1))}px`;
        }
        if (layoutItem.height === newHeight)
            return;
        updateLayoutItem(Object.assign(Object.assign({}, layoutItem), { height: newHeight }));
    }, [(_a = ref.current) === null || _a === void 0 ? void 0 : _a.clientWidth, layoutItem, screenHeight, updateLayoutItem]);
    return (React.createElement(Box, { ref: ref },
        React.createElement(Editable, { renderElement: renderElement, renderLeaf: renderLeaf, autoFocus: true, style: {
                width: "100%",
                height: "fit-content",
                cursor: isEditing ? "text" : "grab",
                backgroundColor: textData.backgroundColor,
                // overflow: "hidden",
            }, onClick: (e) => {
                setIsEditing(true);
            }, className: isEditing ? "rnd-cancel" : "", onBlur: () => {
                setIsEditing(false);
                if (!editor)
                    return;
                onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(Object.assign(Object.assign({}, textData), { text: editor.children }));
            }, onKeyUp: (e) => {
                var _a, _b, _c, _d;
                let newWidth = layoutItem.width;
                let newHeight = layoutItem.height;
                if (layoutItem.unit === "%") {
                    newWidth = pxToPercents((e.currentTarget.clientWidth * ((_a = layoutItem === null || layoutItem === void 0 ? void 0 : layoutItem.scale) !== null && _a !== void 0 ? _a : 1)).toString(), screenWidth);
                    newHeight = pxToPercents((e.currentTarget.clientHeight * ((_b = layoutItem === null || layoutItem === void 0 ? void 0 : layoutItem.scale) !== null && _b !== void 0 ? _b : 1)).toString(), screenHeight);
                }
                if (layoutItem.unit === "px") {
                    newWidth = `${Math.round(e.currentTarget.clientWidth * ((_c = layoutItem === null || layoutItem === void 0 ? void 0 : layoutItem.scale) !== null && _c !== void 0 ? _c : 1))}px`;
                    newHeight = `${Math.round(e.currentTarget.clientHeight * ((_d = layoutItem === null || layoutItem === void 0 ? void 0 : layoutItem.scale) !== null && _d !== void 0 ? _d : 1))}px`;
                }
                if ((layoutItem.width === "auto" || newWidth === layoutItem.width) &&
                    newHeight === layoutItem.height)
                    return;
                updateLayoutItem(Object.assign(Object.assign({}, layoutItem), { width: newWidth, height: newHeight }));
            } })));
};
